// @ts-nocheck
import { getBootstrapModal } from '@/utils/bootstrap';
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  handleWithdrawalClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this._showModal();
  }

  _showModal() {
    const modalElement = document.getElementById('withdrawalConfirmModal');
    if (!modalElement) return;

    const ModalCtor = getBootstrapModal();
    const modalInstance = new ModalCtor(modalElement);
    modalInstance.show();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
